  import { defineComponent, type PropType } from "vue";
  import BrancheSelect from '@/extend/controls/branche/BrancheSelect';
  import CaisseSelectComplementaire from '@/extend/controls/caisse/CaisseSelectComplementaire';
  import ContactSelect from '@/extend/controls/contact/ContactSelect';
  import ContactSummary from '@/extend/controls/contact/ContactSummary';
  import ConventionBrancheList from '@/extend/controls/convention/ConventionBrancheList';
  import EtablissementAccordCollectif from '@/extend/controls/etablissement/EtablissementAccordCollectif';
  import EtablissementAlias from '@/extend/controls/etablissement/EtablissementAlias';
  import EtablissementBrancheCode from '@/extend/controls/etablissement/EtablissementBrancheCode';
  import EtablissementBrancheNom from '@/extend/controls/etablissement/EtablissementBrancheNom';
  import EtablissementCongesSpec from '@/extend/controls/etablissement/EtablissementCongesSpec';
  import EtablissementConventionCode from '@/extend/controls/etablissement/EtablissementConventionCode';
  import EtablissementConventionNom from '@/extend/controls/etablissement/EtablissementConventionNom';
  import EtablissementDateCreation from '@/extend/controls/etablissement/EtablissementDateCreation';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import EtablissementFcap from '@/extend/controls/etablissement/EtablissementFcap';
  import EtablissementFnas from '@/extend/controls/etablissement/EtablissementFnas';
  import EtablissementIdentAssociation from '@/extend/controls/etablissement/EtablissementIdentAssociation';
  import EtablissementLicenceSpectacle from '@/extend/controls/etablissement/EtablissementLicenceSpectacle';
  import EtablissementLicenceStatus from '@/extend/controls/etablissement/EtablissementLicenceStatus';
  import EtablissementLicenceValidite from '@/extend/controls/etablissement/EtablissementLicenceValidite';
  import EtablissementLogo from '@/extend/controls/etablissement/EtablissementLogo';
  import EtablissementMail from '@/extend/controls/etablissement/EtablissementMail';
  import EtablissementModeFacture from '@/extend/controls/etablissement/EtablissementModeFacture';
  import EtablissementNom from '@/extend/controls/etablissement/EtablissementNom';
  import EtablissementNumero from '@/extend/controls/etablissement/EtablissementNumero';
  import EtablissementPaymentAutoSalaire from '@/extend/controls/etablissement/EtablissementPaymentAutoSalaire';
  import EtablissementPoleEmploiAdhesion from '@/extend/controls/etablissement/EtablissementPoleEmploiAdhesion';
  import EtablissementPoleEmploiAffiliation from '@/extend/controls/etablissement/EtablissementPoleEmploiAffiliation';
  import EtablissementPoleEmploiIdentifiant from '@/extend/controls/etablissement/EtablissementPoleEmploiIdentifiant';
  import EtablissementSiret from '@/extend/controls/etablissement/EtablissementSiret';
  import EtablissementSoumisTva from '@/extend/controls/etablissement/EtablissementSoumisTva';
  import EtablissementStatutLicenceSpectacle from '@/extend/controls/etablissement/EtablissementStatutLicenceSpectacle';
  import EtablissementT1790 from '@/extend/controls/etablissement/EtablissementT1790';
  import EtablissementT3252 from '@/extend/controls/etablissement/EtablissementT3252';
  import EtablissementUrssaf from '@/extend/controls/etablissement/EtablissementUrssaf';
  import EtablissementUserDisabled from '@/extend/controls/etablissement/EtablissementUserDisabled';
  import EtablissementVille from '@/extend/controls/etablissement/EtablissementVille';
  import FormeJuridiqueSelect from '@/extend/controls/formeJuridique/FormeJuridiqueSelect';
  import PaymentMeansSummary from '@/extend/controls/paymentMeans/PaymentMeansSummary';
  import RibSummary from '@/extend/controls/rib/RibSummary';
  import TrancheEffectifSelect from '@/extend/controls/trancheEffectif/TrancheEffectifSelect';
  import Etablissement from '@/extend/classes/Etablissement';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeEtablissement } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      BrancheSelect,
      CaisseSelectComplementaire,
      ContactSelect,
      ContactSummary,
      ConventionBrancheList,
      EtablissementAccordCollectif,
      EtablissementAlias,
      EtablissementBrancheCode,
      EtablissementBrancheNom,
      EtablissementCongesSpec,
      EtablissementConventionCode,
      EtablissementConventionNom,
      EtablissementDateCreation,
      EtablissementFcap,
      EtablissementFnas,
      EtablissementIdentAssociation,
      EtablissementLicenceSpectacle,
      EtablissementLicenceStatus,
      EtablissementLicenceValidite,
      EtablissementLogo,
      EtablissementMail,
      EtablissementModeFacture,
      EtablissementNom,
      EtablissementNumero,
      EtablissementPaymentAutoSalaire,
      EtablissementPoleEmploiAdhesion,
      EtablissementPoleEmploiAffiliation,
      EtablissementPoleEmploiIdentifiant,
      EtablissementSiret,
      EtablissementSoumisTva,
      EtablissementStatutLicenceSpectacle,
      EtablissementT1790,
      EtablissementT3252,
      EtablissementUrssaf,
      EtablissementUserDisabled,
      EtablissementVille,
      FormeJuridiqueSelect,
      PaymentMeansSummary,
      RibSummary,
      TrancheEffectifSelect,
    },

    props: {
      etablissement: {
        type: Object as PropType<Etablissement>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetBrancheSelect: {
        type: Boolean
      },
      toggleResetCaisseSelectComplementaire: {
        type: Boolean
      },
      toggleResetContactSelect: {
        type: Boolean
      },
      toggleResetConventionBrancheList: {
        type: Boolean
      },
      toggleResetFormeJuridiqueSelect: {
        type: Boolean
      },
      toggleResetTrancheEffectifSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
    toggleBrancheId: false,
        brancheIdStatus: new FieldStatus(false, false, 0),
        strBrancheId: '',
    toggleRetraiteComplementaireId: false,
        retraiteComplementaireIdStatus: new FieldStatus(false, false, 0),
        strRetraiteComplementaireId: '',
    toggleCommercialId: false,
        commercialIdStatus: new FieldStatus(false, false, 0),
        strCommercialId: '',
    toggleRepresentantId: false,
        representantIdStatus: new FieldStatus(false, false, 0),
        strRepresentantId: '',
    toggleConventionId: false,
        conventionIdStatus: new FieldStatus(false, false, 0),
        strConventionId: '',
        accordCollectifStatus: new FieldStatus(false, false, 0),
        strAccordCollectif: '',
        aliasStatus: new FieldStatus(false, false, 0),
        strAlias: '',
        brancheCodeStatus: new FieldStatus(false, false, 0),
        strBrancheCode: '',
        brancheNomStatus: new FieldStatus(false, false, 0),
        strBrancheNom: '',
        congesSpecStatus: new FieldStatus(false, false, 0),
        strCongesSpec: '',
        conventionCodeStatus: new FieldStatus(false, false, 0),
        strConventionCode: '',
        conventionNomStatus: new FieldStatus(false, false, 0),
        strConventionNom: '',
        dateCreationStatus: new FieldStatus(false, false, 0),
        strDateCreation: '',
        fcapStatus: new FieldStatus(false, false, 0),
        strFcap: '',
        fnasStatus: new FieldStatus(false, false, 0),
        strFnas: '',
        identAssociationStatus: new FieldStatus(false, false, 0),
        strIdentAssociation: '',
        licenceSpectacleStatus: new FieldStatus(false, false, 0),
        strLicenceSpectacle: '',
        licenceStatusStatus: new FieldStatus(false, false, 0),
        strLicenceStatus: '',
        licenceValiditeStatus: new FieldStatus(false, false, 0),
        strLicenceValidite: '',
        logoStatus: new FieldStatus(false, false, 0),
        strLogo: '',
        mailStatus: new FieldStatus(false, false, 0),
        strMail: '',
        modeFactureStatus: new FieldStatus(false, false, 0),
        strModeFacture: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        numeroStatus: new FieldStatus(false, false, 0),
        strNumero: '',
        paymentAutoSalaireStatus: new FieldStatus(false, false, 0),
        strPaymentAutoSalaire: '',
        poleEmploiAdhesionStatus: new FieldStatus(false, false, 0),
        strPoleEmploiAdhesion: '',
        poleEmploiAffiliationStatus: new FieldStatus(false, false, 0),
        strPoleEmploiAffiliation: '',
        poleEmploiIdentifiantStatus: new FieldStatus(false, false, 0),
        strPoleEmploiIdentifiant: '',
        siretStatus: new FieldStatus(false, false, 0),
        strSiret: '',
        soumisTvaStatus: new FieldStatus(false, false, 0),
        strSoumisTva: '',
        statutLicenceSpectacleStatus: new FieldStatus(false, false, 0),
        strStatutLicenceSpectacle: '',
        t1790Status: new FieldStatus(false, false, 0),
        strT1790: '',
        t3252Status: new FieldStatus(false, false, 0),
        strT3252: '',
        urssafStatus: new FieldStatus(false, false, 0),
        strUrssaf: '',
        userDisabledStatus: new FieldStatus(false, false, 0),
        strUserDisabled: '',
        villeStatus: new FieldStatus(false, false, 0),
        strVille: '',
    toggleFormeJuridiqueId: false,
        formeJuridiqueIdStatus: new FieldStatus(false, false, 0),
        strFormeJuridiqueId: '',
    toggleSalaireMeansId: false,
        salaireMeansIdStatus: new FieldStatus(false, false, 0),
        strSalaireMeansId: '',
    togglePrelevRibId: false,
        prelevRibIdStatus: new FieldStatus(false, false, 0),
        strPrelevRibId: '',
    toggleTrancheEffectifId: false,
        trancheEffectifIdStatus: new FieldStatus(false, false, 0),
        strTrancheEffectifId: '',
        refEtablissement: new Etablissement,
        cloneEtablissement: new Etablissement,
      etablissementSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.ETABLISSEMENT,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editEtablissement.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editEtablissement: {
        get(): Etablissement {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.etablissement != undefined) {
              if (this.etablissement.id == 0) {
                Alerts.debug('CrudEtablissement : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneEtablissement.id != this.etablissement.id && !this.saving) {
                this.handleEtablissementChange();
              }
            }
          }
          return this.refEtablissement;
        },
        set(value: Etablissement) {
          this.refEtablissement = value;
        }
      },

      canCreate (): boolean {
        return this.refEtablissement.id > 0;
      },

      canDelete (): boolean {
        return this.refEtablissement.canDelete && this.refEtablissement.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },

    resetBrancheId (): boolean {
      return this.toggleBrancheId
    },

      brancheId: {
        get(): number {
          return this.editEtablissement.brancheId;
        },
        set(value: number) {
          this.editEtablissement.brancheId = value;
          this.fieldUpdated('BRANCHE_ID', value);
        }
      },

    resetRetraiteComplementaireId (): boolean {
      return this.toggleRetraiteComplementaireId
    },

      retraiteComplementaireId: {
        get(): number {
          return this.editEtablissement.retraiteComplementaireId;
        },
        set(value: number) {
          this.editEtablissement.retraiteComplementaireId = value;
          this.fieldUpdated('RETRAITE_COMPLEMENTAIRE_ID', value);
        }
      },

    resetCommercialId (): boolean {
      return this.toggleCommercialId
    },

      commercialId: {
        get(): number {
          return this.editEtablissement.commercialId;
        },
        set(value: number) {
          this.editEtablissement.commercialId = value;
          this.fieldUpdated('COMMERCIAL_ID', value);
        }
      },

    resetRepresentantId (): boolean {
      return this.toggleRepresentantId
    },

      representantId: {
        get(): number {
          return this.editEtablissement.representantId;
        },
        set(value: number) {
          this.editEtablissement.representantId = value;
          this.fieldUpdated('REPRESENTANT_ID', value);
        }
      },

    resetConventionId (): boolean {
      return this.toggleConventionId
    },

      conventionId: {
        get(): number {
          return this.editEtablissement.conventionId;
        },
        set(value: number) {
          this.editEtablissement.conventionId = value;
          this.fieldUpdated('CONVENTION_ID', value);
        }
      },


      accordCollectif: {
        get(): boolean | null {
          return this.editEtablissement.accordCollectif;
        },
        set(value: boolean | null) {
          this.editEtablissement.accordCollectif = value;
          this.fieldUpdated('ACCORD_COLLECTIF', value);
        }
      },


      alias: {
        get(): string {
          return this.editEtablissement.alias;
        },
        set(value: string) {
          this.editEtablissement.alias = value;
          this.fieldUpdated('ALIAS', value);
        }
      },


      brancheCode: {
        get(): string {
          return this.editEtablissement.brancheCode;
        },
        set(value: string) {
          this.editEtablissement.brancheCode = value;
          this.fieldUpdated('BRANCHE_CODE', value);
        }
      },


      brancheNom: {
        get(): string {
          return this.editEtablissement.brancheNom;
        },
        set(value: string) {
          this.editEtablissement.brancheNom = value;
          this.fieldUpdated('BRANCHE_NOM', value);
        }
      },


      congesSpec: {
        get(): string {
          return this.editEtablissement.congesSpec;
        },
        set(value: string) {
          this.editEtablissement.congesSpec = value;
          this.fieldUpdated('CONGES_SPEC', value);
        }
      },


      conventionCode: {
        get(): string {
          return this.editEtablissement.conventionCode;
        },
        set(value: string) {
          this.editEtablissement.conventionCode = value;
          this.fieldUpdated('CONVENTION_CODE', value);
        }
      },


      conventionNom: {
        get(): string {
          return this.editEtablissement.conventionNom;
        },
        set(value: string) {
          this.editEtablissement.conventionNom = value;
          this.fieldUpdated('CONVENTION_NOM', value);
        }
      },


      dateCreation: {
        get(): Date {
          return this.editEtablissement.dateCreation;
        },
        set(value: Date) {
          this.editEtablissement.dateCreation = value;
          this.fieldUpdated('DATE_CREATION', value);
        }
      },

      periodDateCreation() : Period[] {
        return []
      },

      fcap: {
        get(): string {
          return this.editEtablissement.fcap;
        },
        set(value: string) {
          this.editEtablissement.fcap = value;
          this.fieldUpdated('FCAP', value);
        }
      },


      fnas: {
        get(): string {
          return this.editEtablissement.fnas;
        },
        set(value: string) {
          this.editEtablissement.fnas = value;
          this.fieldUpdated('FNAS', value);
        }
      },


      identAssociation: {
        get(): string {
          return this.editEtablissement.identAssociation;
        },
        set(value: string) {
          this.editEtablissement.identAssociation = value;
          this.fieldUpdated('IDENT_ASSOCIATION', value);
        }
      },


      licenceSpectacle: {
        get(): string {
          return this.editEtablissement.licenceSpectacle;
        },
        set(value: string) {
          this.editEtablissement.licenceSpectacle = value;
          this.fieldUpdated('LICENCE_SPECTACLE', value);
        }
      },


      licenceStatus: {
        get(): number {
          return this.editEtablissement.licenceStatus;
        },
        set(value: number) {
          this.editEtablissement.licenceStatus = value;
          this.fieldUpdated('LICENCE_STATUS', value);
        }
      },


      licenceValidite: {
        get(): Date | null {
          return this.editEtablissement.licenceValidite;
        },
        set(value: Date | null) {
          this.editEtablissement.licenceValidite = value;
          this.fieldUpdated('LICENCE_VALIDITE', value);
        }
      },

      periodLicenceValidite() : Period[] {
        return []
      },

      logo: {
        get(): string {
          return this.editEtablissement.logo;
        },
        set(value: string) {
          this.editEtablissement.logo = value;
          this.fieldUpdated('LOGO', value);
        }
      },


      mail: {
        get(): string {
          return this.editEtablissement.mail;
        },
        set(value: string) {
          this.editEtablissement.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      },


      modeFacture: {
        get(): number {
          return this.editEtablissement.modeFacture;
        },
        set(value: number) {
          this.editEtablissement.modeFacture = value;
          this.fieldUpdated('MODE_FACTURE', value);
        }
      },


      nom: {
        get(): string {
          return this.editEtablissement.nom;
        },
        set(value: string) {
          this.editEtablissement.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      numero: {
        get(): string {
          return this.editEtablissement.numero;
        },
        set(value: string) {
          this.editEtablissement.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },


      paymentAutoSalaire: {
        get(): boolean {
          return this.editEtablissement.paymentAutoSalaire;
        },
        set(value: boolean) {
          this.editEtablissement.paymentAutoSalaire = value;
          this.fieldUpdated('PAYMENT_AUTO_SALAIRE', value);
        }
      },


      poleEmploiAdhesion: {
        get(): string {
          return this.editEtablissement.poleEmploiAdhesion;
        },
        set(value: string) {
          this.editEtablissement.poleEmploiAdhesion = value;
          this.fieldUpdated('POLE_EMPLOI_ADHESION', value);
        }
      },


      poleEmploiAffiliation: {
        get(): string {
          return this.editEtablissement.poleEmploiAffiliation;
        },
        set(value: string) {
          this.editEtablissement.poleEmploiAffiliation = value;
          this.fieldUpdated('POLE_EMPLOI_AFFILIATION', value);
        }
      },


      poleEmploiIdentifiant: {
        get(): string {
          return this.editEtablissement.poleEmploiIdentifiant;
        },
        set(value: string) {
          this.editEtablissement.poleEmploiIdentifiant = value;
          this.fieldUpdated('POLE_EMPLOI_IDENTIFIANT', value);
        }
      },


      siret: {
        get(): string {
          return this.editEtablissement.siret;
        },
        set(value: string) {
          this.editEtablissement.siret = value;
          this.fieldUpdated('SIRET', value);
        }
      },


      soumisTva: {
        get(): boolean | null {
          return this.editEtablissement.soumisTva;
        },
        set(value: boolean | null) {
          this.editEtablissement.soumisTva = value;
          this.fieldUpdated('SOUMIS_TVA', value);
        }
      },


      statutLicenceSpectacle: {
        get(): string {
          return this.editEtablissement.statutLicenceSpectacle;
        },
        set(value: string) {
          this.editEtablissement.statutLicenceSpectacle = value;
          this.fieldUpdated('STATUT_LICENCE_SPECTACLE', value);
        }
      },


      t1790: {
        get(): number {
          return this.editEtablissement.t1790;
        },
        set(value: number) {
          this.editEtablissement.t1790 = value;
          this.fieldUpdated('T1790', value);
        }
      },


      t3252: {
        get(): number {
          return this.editEtablissement.t3252;
        },
        set(value: number) {
          this.editEtablissement.t3252 = value;
          this.fieldUpdated('T3252', value);
        }
      },


      urssaf: {
        get(): string {
          return this.editEtablissement.urssaf;
        },
        set(value: string) {
          this.editEtablissement.urssaf = value;
          this.fieldUpdated('URSSAF', value);
        }
      },


      userDisabled: {
        get(): boolean {
          return this.editEtablissement.userDisabled;
        },
        set(value: boolean) {
          this.editEtablissement.userDisabled = value;
          this.fieldUpdated('USER_DISABLED', value);
        }
      },


      ville: {
        get(): string {
          return this.editEtablissement.ville;
        },
        set(value: string) {
          this.editEtablissement.ville = value;
          this.fieldUpdated('VILLE', value);
        }
      },

    resetFormeJuridiqueId (): boolean {
      return this.toggleFormeJuridiqueId
    },

      formeJuridiqueId: {
        get(): number {
          return this.editEtablissement.formeJuridiqueId;
        },
        set(value: number) {
          this.editEtablissement.formeJuridiqueId = value;
          this.fieldUpdated('FORME_JURIDIQUE_ID', value);
        }
      },

    resetSalaireMeansId (): boolean {
      return this.toggleSalaireMeansId
    },

      salaireMeansId: {
        get(): number {
          return this.editEtablissement.salaireMeansId;
        },
        set(value: number) {
          this.editEtablissement.salaireMeansId = value;
          this.fieldUpdated('SALAIRE_MEANS_ID', value);
        }
      },

    resetPrelevRibId (): boolean {
      return this.togglePrelevRibId
    },

      prelevRibId: {
        get(): number {
          return this.editEtablissement.prelevRibId;
        },
        set(value: number) {
          this.editEtablissement.prelevRibId = value;
          this.fieldUpdated('PRELEV_RIB_ID', value);
        }
      },

    resetTrancheEffectifId (): boolean {
      return this.toggleTrancheEffectifId
    },

      trancheEffectifId: {
        get(): number {
          return this.editEtablissement.trancheEffectifId;
        },
        set(value: number) {
          this.editEtablissement.trancheEffectifId = value;
          this.fieldUpdated('TRANCHE_EFFECTIF_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.etablissement.canUpdate && (
        (this.isDisplayed('BRANCHE_ID') && !this.readOnly('BRANCHE_ID')) ||
        (this.isDisplayed('RETRAITE_COMPLEMENTAIRE_ID') && !this.readOnly('RETRAITE_COMPLEMENTAIRE_ID')) ||
        (this.isDisplayed('COMMERCIAL_ID') && !this.readOnly('COMMERCIAL_ID')) ||
        (this.isDisplayed('REPRESENTANT_ID') && !this.readOnly('REPRESENTANT_ID')) ||
        (this.isDisplayed('CONVENTION_ID') && !this.readOnly('CONVENTION_ID')) ||
        (this.isDisplayed('ACCORD_COLLECTIF') && !this.readOnly('ACCORD_COLLECTIF')) ||
        (this.isDisplayed('ALIAS') && !this.readOnly('ALIAS')) ||
        (this.isDisplayed('BRANCHE_CODE') && !this.readOnly('BRANCHE_CODE')) ||
        (this.isDisplayed('BRANCHE_NOM') && !this.readOnly('BRANCHE_NOM')) ||
        (this.isDisplayed('CONGES_SPEC') && !this.readOnly('CONGES_SPEC')) ||
        (this.isDisplayed('CONVENTION_CODE') && !this.readOnly('CONVENTION_CODE')) ||
        (this.isDisplayed('CONVENTION_NOM') && !this.readOnly('CONVENTION_NOM')) ||
        (this.isDisplayed('DATE_CREATION') && !this.readOnly('DATE_CREATION')) ||
        (this.isDisplayed('FCAP') && !this.readOnly('FCAP')) ||
        (this.isDisplayed('FNAS') && !this.readOnly('FNAS')) ||
        (this.isDisplayed('IDENT_ASSOCIATION') && !this.readOnly('IDENT_ASSOCIATION')) ||
        (this.isDisplayed('LICENCE_SPECTACLE') && !this.readOnly('LICENCE_SPECTACLE')) ||
        (this.isDisplayed('LICENCE_STATUS') && !this.readOnly('LICENCE_STATUS')) ||
        (this.isDisplayed('LICENCE_VALIDITE') && !this.readOnly('LICENCE_VALIDITE')) ||
        (this.isDisplayed('LOGO') && !this.readOnly('LOGO')) ||
        (this.isDisplayed('MAIL') && !this.readOnly('MAIL')) ||
        (this.isDisplayed('MODE_FACTURE') && !this.readOnly('MODE_FACTURE')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('NUMERO') && !this.readOnly('NUMERO')) ||
        (this.isDisplayed('PAYMENT_AUTO_SALAIRE') && !this.readOnly('PAYMENT_AUTO_SALAIRE')) ||
        (this.isDisplayed('POLE_EMPLOI_ADHESION') && !this.readOnly('POLE_EMPLOI_ADHESION')) ||
        (this.isDisplayed('POLE_EMPLOI_AFFILIATION') && !this.readOnly('POLE_EMPLOI_AFFILIATION')) ||
        (this.isDisplayed('POLE_EMPLOI_IDENTIFIANT') && !this.readOnly('POLE_EMPLOI_IDENTIFIANT')) ||
        (this.isDisplayed('SIRET') && !this.readOnly('SIRET')) ||
        (this.isDisplayed('SOUMIS_TVA') && !this.readOnly('SOUMIS_TVA')) ||
        (this.isDisplayed('STATUT_LICENCE_SPECTACLE') && !this.readOnly('STATUT_LICENCE_SPECTACLE')) ||
        (this.isDisplayed('T1790') && !this.readOnly('T1790')) ||
        (this.isDisplayed('T3252') && !this.readOnly('T3252')) ||
        (this.isDisplayed('URSSAF') && !this.readOnly('URSSAF')) ||
        (this.isDisplayed('USER_DISABLED') && !this.readOnly('USER_DISABLED')) ||
        (this.isDisplayed('VILLE') && !this.readOnly('VILLE')) ||
        (this.isDisplayed('FORME_JURIDIQUE_ID') && !this.readOnly('FORME_JURIDIQUE_ID')) ||
        (this.isDisplayed('SALAIRE_MEANS_ID') && !this.readOnly('SALAIRE_MEANS_ID')) ||
        (this.isDisplayed('PRELEV_RIB_ID') && !this.readOnly('PRELEV_RIB_ID')) ||
        (this.isDisplayed('TRANCHE_EFFECTIF_ID') && !this.readOnly('TRANCHE_EFFECTIF_ID')));
        return !res;
      },

      fields (): string[] {
        return ['BRANCHE_ID', 'RETRAITE_COMPLEMENTAIRE_ID', 'COMMERCIAL_ID', 'REPRESENTANT_ID', 'CONVENTION_ID', 'ACCORD_COLLECTIF', 'ALIAS', 'BRANCHE_CODE', 'BRANCHE_NOM', 'CONGES_SPEC', 'CONVENTION_CODE', 'CONVENTION_NOM', 'DATE_CREATION', 'FCAP', 'FNAS', 'IDENT_ASSOCIATION', 'LICENCE_SPECTACLE', 'LICENCE_STATUS', 'LICENCE_VALIDITE', 'LOGO', 'MAIL', 'MODE_FACTURE', 'NOM', 'NUMERO', 'PAYMENT_AUTO_SALAIRE', 'POLE_EMPLOI_ADHESION', 'POLE_EMPLOI_AFFILIATION', 'POLE_EMPLOI_IDENTIFIANT', 'SIRET', 'SOUMIS_TVA', 'STATUT_LICENCE_SPECTACLE', 'T1790', 'T3252', 'URSSAF', 'USER_DISABLED', 'VILLE', 'FORME_JURIDIQUE_ID', 'SALAIRE_MEANS_ID', 'PRELEV_RIB_ID', 'TRANCHE_EFFECTIF_ID'];
      },
    },

    methods: {
      handleEtablissementChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.etablissement);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.etablissement);
          }
        } else if (!this.inDialog) {
          if (this.cloneEtablissement.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.etablissement);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.brancheIdStatus != undefined && this.brancheIdStatus.updated) ||
          (this.retraiteComplementaireIdStatus != undefined && this.retraiteComplementaireIdStatus.updated) ||
          (this.commercialIdStatus != undefined && this.commercialIdStatus.updated) ||
          (this.representantIdStatus != undefined && this.representantIdStatus.updated) ||
          (this.conventionIdStatus != undefined && this.conventionIdStatus.updated) ||
          (this.accordCollectifStatus != undefined && this.accordCollectifStatus.updated) ||
          (this.aliasStatus != undefined && this.aliasStatus.updated) ||
          (this.brancheCodeStatus != undefined && this.brancheCodeStatus.updated) ||
          (this.brancheNomStatus != undefined && this.brancheNomStatus.updated) ||
          (this.congesSpecStatus != undefined && this.congesSpecStatus.updated) ||
          (this.conventionCodeStatus != undefined && this.conventionCodeStatus.updated) ||
          (this.conventionNomStatus != undefined && this.conventionNomStatus.updated) ||
          (this.dateCreationStatus != undefined && this.dateCreationStatus.updated) ||
          (this.fcapStatus != undefined && this.fcapStatus.updated) ||
          (this.fnasStatus != undefined && this.fnasStatus.updated) ||
          (this.identAssociationStatus != undefined && this.identAssociationStatus.updated) ||
          (this.licenceSpectacleStatus != undefined && this.licenceSpectacleStatus.updated) ||
          (this.licenceStatusStatus != undefined && this.licenceStatusStatus.updated) ||
          (this.licenceValiditeStatus != undefined && this.licenceValiditeStatus.updated) ||
          (this.logoStatus != undefined && this.logoStatus.updated) ||
          (this.mailStatus != undefined && this.mailStatus.updated) ||
          (this.modeFactureStatus != undefined && this.modeFactureStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.numeroStatus != undefined && this.numeroStatus.updated) ||
          (this.paymentAutoSalaireStatus != undefined && this.paymentAutoSalaireStatus.updated) ||
          (this.poleEmploiAdhesionStatus != undefined && this.poleEmploiAdhesionStatus.updated) ||
          (this.poleEmploiAffiliationStatus != undefined && this.poleEmploiAffiliationStatus.updated) ||
          (this.poleEmploiIdentifiantStatus != undefined && this.poleEmploiIdentifiantStatus.updated) ||
          (this.siretStatus != undefined && this.siretStatus.updated) ||
          (this.soumisTvaStatus != undefined && this.soumisTvaStatus.updated) ||
          (this.statutLicenceSpectacleStatus != undefined && this.statutLicenceSpectacleStatus.updated) ||
          (this.t1790Status != undefined && this.t1790Status.updated) ||
          (this.t3252Status != undefined && this.t3252Status.updated) ||
          (this.urssafStatus != undefined && this.urssafStatus.updated) ||
          (this.userDisabledStatus != undefined && this.userDisabledStatus.updated) ||
          (this.villeStatus != undefined && this.villeStatus.updated) ||
          (this.formeJuridiqueIdStatus != undefined && this.formeJuridiqueIdStatus.updated) ||
          (this.salaireMeansIdStatus != undefined && this.salaireMeansIdStatus.updated) ||
          (this.prelevRibIdStatus != undefined && this.prelevRibIdStatus.updated) ||
          (this.trancheEffectifIdStatus != undefined && this.trancheEffectifIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.etablissement);
        }
      },

      setError (): void {
        const error = this.brancheIdStatus.error ||
        this.retraiteComplementaireIdStatus.error ||
        this.commercialIdStatus.error ||
        this.representantIdStatus.error ||
        this.conventionIdStatus.error ||
        this.accordCollectifStatus.error ||
        this.aliasStatus.error ||
        this.brancheCodeStatus.error ||
        this.brancheNomStatus.error ||
        this.congesSpecStatus.error ||
        this.conventionCodeStatus.error ||
        this.conventionNomStatus.error ||
        this.dateCreationStatus.error ||
        this.fcapStatus.error ||
        this.fnasStatus.error ||
        this.identAssociationStatus.error ||
        this.licenceSpectacleStatus.error ||
        this.licenceStatusStatus.error ||
        this.licenceValiditeStatus.error ||
        this.logoStatus.error ||
        this.mailStatus.error ||
        this.modeFactureStatus.error ||
        this.nomStatus.error ||
        this.numeroStatus.error ||
        this.paymentAutoSalaireStatus.error ||
        this.poleEmploiAdhesionStatus.error ||
        this.poleEmploiAffiliationStatus.error ||
        this.poleEmploiIdentifiantStatus.error ||
        this.siretStatus.error ||
        this.soumisTvaStatus.error ||
        this.statutLicenceSpectacleStatus.error ||
        this.t1790Status.error ||
        this.t3252Status.error ||
        this.urssafStatus.error ||
        this.userDisabledStatus.error ||
        this.villeStatus.error ||
        this.formeJuridiqueIdStatus.error ||
        this.salaireMeansIdStatus.error ||
        this.prelevRibIdStatus.error ||
        this.trancheEffectifIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.etablissement);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refEtablissement.id < 0) {
          storeEtablissement.mEtablissementDeleted(this.refEtablissement.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refEtablissement.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveEtablissement()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.etablissementSaving = false;
          this.createRef(this.refEtablissement);
          this.$emit('updated', this.refEtablissement);
          if (this.etablissement.id > 0) {
            this.$emit('saved', this.refEtablissement);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refEtablissement.failed) {
          this.saveLoading = false;
            this.etablissementSaving = false;
            this.refEtablissement.failed = false;
          }
        }
      },

      saveEtablissement (): boolean {
        if (!this.refEtablissement.compareEtablissement(this.cloneEtablissement)) {
          if (!this.etablissementSaving) {
            this.etablissementSaving = true;
          if (this.refEtablissement.id > 0) {
            storeEtablissement.updateEtablissement(this.refEtablissement)
              .then((data: Etablissement) => {
                if (!data.failed) {
                  this.refEtablissement = storeEtablissement.getEtablissement(data.id);
                  this.cloneEtablissement = data.cloneEtablissement();
                } else {
                  this.refEtablissement.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.etablissementSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refEtablissement.id <= 0) {
              storeEtablissement.createEtablissement(this.refEtablissement)
                .then((data: Etablissement) => {
                  if (!data.failed) {
                    this.refEtablissement = storeEtablissement.getEtablissement(data.id);
                    this.cloneEtablissement = data.cloneEtablissement();
                  } else {
                this.refEtablissement.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.etablissementSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refEtablissement.id <= 0) {
          storeEtablissement.mEtablissementDeleted(this.refEtablissement.id);
        } else {
          storeEtablissement.deleteEtablissement(this.refEtablissement);
        }
      },

      statusBrancheId (value: FieldStatus): void {
        this.brancheIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusRetraiteComplementaireId (value: FieldStatus): void {
        this.retraiteComplementaireIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusCommercialId (value: FieldStatus): void {
        this.commercialIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusRepresentantId (value: FieldStatus): void {
        this.representantIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusConventionId (value: FieldStatus): void {
        this.conventionIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAccordCollectif (value: FieldStatus): void {
        this.accordCollectifStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAlias (value: FieldStatus): void {
        this.aliasStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusBrancheCode (value: FieldStatus): void {
        this.brancheCodeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusBrancheNom (value: FieldStatus): void {
        this.brancheNomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusCongesSpec (value: FieldStatus): void {
        this.congesSpecStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusConventionCode (value: FieldStatus): void {
        this.conventionCodeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusConventionNom (value: FieldStatus): void {
        this.conventionNomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateCreation (value: FieldStatus): void {
        this.dateCreationStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusFcap (value: FieldStatus): void {
        this.fcapStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusFnas (value: FieldStatus): void {
        this.fnasStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusIdentAssociation (value: FieldStatus): void {
        this.identAssociationStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLicenceSpectacle (value: FieldStatus): void {
        this.licenceSpectacleStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLicenceStatus (value: FieldStatus): void {
        this.licenceStatusStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLicenceValidite (value: FieldStatus): void {
        this.licenceValiditeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLogo (value: FieldStatus): void {
        this.logoStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMail (value: FieldStatus): void {
        this.mailStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusModeFacture (value: FieldStatus): void {
        this.modeFactureStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumero (value: FieldStatus): void {
        this.numeroStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPaymentAutoSalaire (value: FieldStatus): void {
        this.paymentAutoSalaireStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPoleEmploiAdhesion (value: FieldStatus): void {
        this.poleEmploiAdhesionStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPoleEmploiAffiliation (value: FieldStatus): void {
        this.poleEmploiAffiliationStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPoleEmploiIdentifiant (value: FieldStatus): void {
        this.poleEmploiIdentifiantStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusSiret (value: FieldStatus): void {
        this.siretStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusSoumisTva (value: FieldStatus): void {
        this.soumisTvaStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusStatutLicenceSpectacle (value: FieldStatus): void {
        this.statutLicenceSpectacleStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusT1790 (value: FieldStatus): void {
        this.t1790Status = value;
        this.setUpdated();
        this.setError();
      },
      statusT3252 (value: FieldStatus): void {
        this.t3252Status = value;
        this.setUpdated();
        this.setError();
      },
      statusUrssaf (value: FieldStatus): void {
        this.urssafStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusUserDisabled (value: FieldStatus): void {
        this.userDisabledStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusVille (value: FieldStatus): void {
        this.villeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusFormeJuridiqueId (value: FieldStatus): void {
        this.formeJuridiqueIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusSalaireMeansId (value: FieldStatus): void {
        this.salaireMeansIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrelevRibId (value: FieldStatus): void {
        this.prelevRibIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusTrancheEffectifId (value: FieldStatus): void {
        this.trancheEffectifIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteEtablissement(): void {
        this.$emit('deleteEtablissement',  this.etablissement);
      },

    addEtablissement(): void {
      this.$emit('addEtablissement',  this.etablissement);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneEtablissement != undefined) {
          this.restoring = true;
          this.refEtablissement.brancheId = this.cloneEtablissement.brancheId;
          this.refEtablissement.retraiteComplementaireId = this.cloneEtablissement.retraiteComplementaireId;
          this.refEtablissement.commercialId = this.cloneEtablissement.commercialId;
          this.refEtablissement.conventionId = this.cloneEtablissement.conventionId;
          this.refEtablissement.accordCollectif = this.cloneEtablissement.accordCollectif;
          this.refEtablissement.alias = this.cloneEtablissement.alias;
          this.refEtablissement.brancheCode = this.cloneEtablissement.brancheCode;
          this.refEtablissement.brancheNom = this.cloneEtablissement.brancheNom;
          this.refEtablissement.congesSpec = this.cloneEtablissement.congesSpec;
          this.refEtablissement.conventionCode = this.cloneEtablissement.conventionCode;
          this.refEtablissement.conventionNom = this.cloneEtablissement.conventionNom;
          this.refEtablissement.dateCreation = this.cloneEtablissement.dateCreation;
          this.refEtablissement.fcap = this.cloneEtablissement.fcap;
          this.refEtablissement.fnas = this.cloneEtablissement.fnas;
          this.refEtablissement.identAssociation = this.cloneEtablissement.identAssociation;
          this.refEtablissement.licenceSpectacle = this.cloneEtablissement.licenceSpectacle;
          this.refEtablissement.licenceStatus = this.cloneEtablissement.licenceStatus;
          this.refEtablissement.licenceValidite = this.cloneEtablissement.licenceValidite;
          this.refEtablissement.logo = this.cloneEtablissement.logo;
          this.refEtablissement.mail = this.cloneEtablissement.mail;
          this.refEtablissement.modeFacture = this.cloneEtablissement.modeFacture;
          this.refEtablissement.nom = this.cloneEtablissement.nom;
          this.refEtablissement.numero = this.cloneEtablissement.numero;
          this.refEtablissement.paymentAutoSalaire = this.cloneEtablissement.paymentAutoSalaire;
          this.refEtablissement.poleEmploiAdhesion = this.cloneEtablissement.poleEmploiAdhesion;
          this.refEtablissement.poleEmploiAffiliation = this.cloneEtablissement.poleEmploiAffiliation;
          this.refEtablissement.poleEmploiIdentifiant = this.cloneEtablissement.poleEmploiIdentifiant;
          this.refEtablissement.siret = this.cloneEtablissement.siret;
          this.refEtablissement.soumisTva = this.cloneEtablissement.soumisTva;
          this.refEtablissement.statutLicenceSpectacle = this.cloneEtablissement.statutLicenceSpectacle;
          this.refEtablissement.t1790 = this.cloneEtablissement.t1790;
          this.refEtablissement.t3252 = this.cloneEtablissement.t3252;
          this.refEtablissement.urssaf = this.cloneEtablissement.urssaf;
          this.refEtablissement.userDisabled = this.cloneEtablissement.userDisabled;
          this.refEtablissement.ville = this.cloneEtablissement.ville;
          this.refEtablissement.formeJuridiqueId = this.cloneEtablissement.formeJuridiqueId;
          this.refEtablissement.trancheEffectifId = this.cloneEtablissement.trancheEffectifId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Etablissement): void {
        this.clearRef();
        this.editEtablissement = value;
        this.cloneEtablissement = value.cloneEtablissement();
        this.brancheIdStatus.clear(value.id);
        this.retraiteComplementaireIdStatus.clear(value.id);
        this.commercialIdStatus.clear(value.id);
        this.representantIdStatus.clear(value.id);
        this.conventionIdStatus.clear(value.id);
        this.accordCollectifStatus.clear(value.id);
        this.aliasStatus.clear(value.id);
        this.brancheCodeStatus.clear(value.id);
        this.brancheNomStatus.clear(value.id);
        this.congesSpecStatus.clear(value.id);
        this.conventionCodeStatus.clear(value.id);
        this.conventionNomStatus.clear(value.id);
        this.dateCreationStatus.clear(value.id);
        this.fcapStatus.clear(value.id);
        this.fnasStatus.clear(value.id);
        this.identAssociationStatus.clear(value.id);
        this.licenceSpectacleStatus.clear(value.id);
        this.licenceStatusStatus.clear(value.id);
        this.licenceValiditeStatus.clear(value.id);
        this.logoStatus.clear(value.id);
        this.mailStatus.clear(value.id);
        this.modeFactureStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.numeroStatus.clear(value.id);
        this.paymentAutoSalaireStatus.clear(value.id);
        this.poleEmploiAdhesionStatus.clear(value.id);
        this.poleEmploiAffiliationStatus.clear(value.id);
        this.poleEmploiIdentifiantStatus.clear(value.id);
        this.siretStatus.clear(value.id);
        this.soumisTvaStatus.clear(value.id);
        this.statutLicenceSpectacleStatus.clear(value.id);
        this.t1790Status.clear(value.id);
        this.t3252Status.clear(value.id);
        this.urssafStatus.clear(value.id);
        this.userDisabledStatus.clear(value.id);
        this.villeStatus.clear(value.id);
        this.formeJuridiqueIdStatus.clear(value.id);
        this.salaireMeansIdStatus.clear(value.id);
        this.prelevRibIdStatus.clear(value.id);
        this.trancheEffectifIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_ID') && this.$refs.BRANCHE_ID) this.$refs.BRANCHE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('RETRAITE_COMPLEMENTAIRE_ID') && this.$refs.RETRAITE_COMPLEMENTAIRE_ID) this.$refs.RETRAITE_COMPLEMENTAIRE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('COMMERCIAL_ID') && this.$refs.COMMERCIAL_ID) this.$refs.COMMERCIAL_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('REPRESENTANT_ID') && this.$refs.REPRESENTANT_ID) this.$refs.REPRESENTANT_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_ID') && this.$refs.CONVENTION_ID) this.$refs.CONVENTION_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ACCORD_COLLECTIF') && this.$refs.ACCORD_COLLECTIF) this.$refs.ACCORD_COLLECTIF.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ALIAS') && this.$refs.ALIAS) this.$refs.ALIAS.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_CODE') && this.$refs.BRANCHE_CODE) this.$refs.BRANCHE_CODE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_NOM') && this.$refs.BRANCHE_NOM) this.$refs.BRANCHE_NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONGES_SPEC') && this.$refs.CONGES_SPEC) this.$refs.CONGES_SPEC.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_CODE') && this.$refs.CONVENTION_CODE) this.$refs.CONVENTION_CODE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_NOM') && this.$refs.CONVENTION_NOM) this.$refs.CONVENTION_NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_CREATION') && this.$refs.DATE_CREATION) this.$refs.DATE_CREATION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FCAP') && this.$refs.FCAP) this.$refs.FCAP.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FNAS') && this.$refs.FNAS) this.$refs.FNAS.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENT_ASSOCIATION') && this.$refs.IDENT_ASSOCIATION) this.$refs.IDENT_ASSOCIATION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_SPECTACLE') && this.$refs.LICENCE_SPECTACLE) this.$refs.LICENCE_SPECTACLE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_STATUS') && this.$refs.LICENCE_STATUS) this.$refs.LICENCE_STATUS.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_VALIDITE') && this.$refs.LICENCE_VALIDITE) this.$refs.LICENCE_VALIDITE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LOGO') && this.$refs.LOGO) this.$refs.LOGO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MODE_FACTURE') && this.$refs.MODE_FACTURE) this.$refs.MODE_FACTURE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYMENT_AUTO_SALAIRE') && this.$refs.PAYMENT_AUTO_SALAIRE) this.$refs.PAYMENT_AUTO_SALAIRE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_ADHESION') && this.$refs.POLE_EMPLOI_ADHESION) this.$refs.POLE_EMPLOI_ADHESION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_AFFILIATION') && this.$refs.POLE_EMPLOI_AFFILIATION) this.$refs.POLE_EMPLOI_AFFILIATION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_IDENTIFIANT') && this.$refs.POLE_EMPLOI_IDENTIFIANT) this.$refs.POLE_EMPLOI_IDENTIFIANT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SIRET') && this.$refs.SIRET) this.$refs.SIRET.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SOUMIS_TVA') && this.$refs.SOUMIS_TVA) this.$refs.SOUMIS_TVA.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT_LICENCE_SPECTACLE') && this.$refs.STATUT_LICENCE_SPECTACLE) this.$refs.STATUT_LICENCE_SPECTACLE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('T1790') && this.$refs.T1790) this.$refs.T1790.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('T3252') && this.$refs.T3252) this.$refs.T3252.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('URSSAF') && this.$refs.URSSAF) this.$refs.URSSAF.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('USER_DISABLED') && this.$refs.USER_DISABLED) this.$refs.USER_DISABLED.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE') && this.$refs.VILLE) this.$refs.VILLE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FORME_JURIDIQUE_ID') && this.$refs.FORME_JURIDIQUE_ID) this.$refs.FORME_JURIDIQUE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SALAIRE_MEANS_ID') && this.$refs.SALAIRE_MEANS_ID) this.$refs.SALAIRE_MEANS_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRELEV_RIB_ID') && this.$refs.PRELEV_RIB_ID) this.$refs.PRELEV_RIB_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TRANCHE_EFFECTIF_ID') && this.$refs.TRANCHE_EFFECTIF_ID) this.$refs.TRANCHE_EFFECTIF_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'BRANCHE_ID') && this.isDisplayed('BRANCHE_ID') && this.$refs.BRANCHE_ID && this.$refs.BRANCHE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'RETRAITE_COMPLEMENTAIRE_ID') && this.isDisplayed('RETRAITE_COMPLEMENTAIRE_ID') && this.$refs.RETRAITE_COMPLEMENTAIRE_ID && this.$refs.RETRAITE_COMPLEMENTAIRE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'COMMERCIAL_ID') && this.isDisplayed('COMMERCIAL_ID') && this.$refs.COMMERCIAL_ID && this.$refs.COMMERCIAL_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'REPRESENTANT_ID') && this.isDisplayed('REPRESENTANT_ID') && this.$refs.REPRESENTANT_ID && this.$refs.REPRESENTANT_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONVENTION_ID') && this.isDisplayed('CONVENTION_ID') && this.$refs.CONVENTION_ID && this.$refs.CONVENTION_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ACCORD_COLLECTIF') && this.isDisplayed('ACCORD_COLLECTIF') && this.$refs.ACCORD_COLLECTIF && this.$refs.ACCORD_COLLECTIF.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ALIAS') && this.isDisplayed('ALIAS') && this.$refs.ALIAS && this.$refs.ALIAS.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'BRANCHE_CODE') && this.isDisplayed('BRANCHE_CODE') && this.$refs.BRANCHE_CODE && this.$refs.BRANCHE_CODE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'BRANCHE_NOM') && this.isDisplayed('BRANCHE_NOM') && this.$refs.BRANCHE_NOM && this.$refs.BRANCHE_NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONGES_SPEC') && this.isDisplayed('CONGES_SPEC') && this.$refs.CONGES_SPEC && this.$refs.CONGES_SPEC.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONVENTION_CODE') && this.isDisplayed('CONVENTION_CODE') && this.$refs.CONVENTION_CODE && this.$refs.CONVENTION_CODE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONVENTION_NOM') && this.isDisplayed('CONVENTION_NOM') && this.$refs.CONVENTION_NOM && this.$refs.CONVENTION_NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_CREATION') && this.isDisplayed('DATE_CREATION') && this.$refs.DATE_CREATION && this.$refs.DATE_CREATION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'FCAP') && this.isDisplayed('FCAP') && this.$refs.FCAP && this.$refs.FCAP.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'FNAS') && this.isDisplayed('FNAS') && this.$refs.FNAS && this.$refs.FNAS.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'IDENT_ASSOCIATION') && this.isDisplayed('IDENT_ASSOCIATION') && this.$refs.IDENT_ASSOCIATION && this.$refs.IDENT_ASSOCIATION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LICENCE_SPECTACLE') && this.isDisplayed('LICENCE_SPECTACLE') && this.$refs.LICENCE_SPECTACLE && this.$refs.LICENCE_SPECTACLE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LICENCE_STATUS') && this.isDisplayed('LICENCE_STATUS') && this.$refs.LICENCE_STATUS && this.$refs.LICENCE_STATUS.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LICENCE_VALIDITE') && this.isDisplayed('LICENCE_VALIDITE') && this.$refs.LICENCE_VALIDITE && this.$refs.LICENCE_VALIDITE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LOGO') && this.isDisplayed('LOGO') && this.$refs.LOGO && this.$refs.LOGO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MAIL') && this.isDisplayed('MAIL') && this.$refs.MAIL && this.$refs.MAIL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MODE_FACTURE') && this.isDisplayed('MODE_FACTURE') && this.$refs.MODE_FACTURE && this.$refs.MODE_FACTURE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO') && this.isDisplayed('NUMERO') && this.$refs.NUMERO && this.$refs.NUMERO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PAYMENT_AUTO_SALAIRE') && this.isDisplayed('PAYMENT_AUTO_SALAIRE') && this.$refs.PAYMENT_AUTO_SALAIRE && this.$refs.PAYMENT_AUTO_SALAIRE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'POLE_EMPLOI_ADHESION') && this.isDisplayed('POLE_EMPLOI_ADHESION') && this.$refs.POLE_EMPLOI_ADHESION && this.$refs.POLE_EMPLOI_ADHESION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'POLE_EMPLOI_AFFILIATION') && this.isDisplayed('POLE_EMPLOI_AFFILIATION') && this.$refs.POLE_EMPLOI_AFFILIATION && this.$refs.POLE_EMPLOI_AFFILIATION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'POLE_EMPLOI_IDENTIFIANT') && this.isDisplayed('POLE_EMPLOI_IDENTIFIANT') && this.$refs.POLE_EMPLOI_IDENTIFIANT && this.$refs.POLE_EMPLOI_IDENTIFIANT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'SIRET') && this.isDisplayed('SIRET') && this.$refs.SIRET && this.$refs.SIRET.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'SOUMIS_TVA') && this.isDisplayed('SOUMIS_TVA') && this.$refs.SOUMIS_TVA && this.$refs.SOUMIS_TVA.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'STATUT_LICENCE_SPECTACLE') && this.isDisplayed('STATUT_LICENCE_SPECTACLE') && this.$refs.STATUT_LICENCE_SPECTACLE && this.$refs.STATUT_LICENCE_SPECTACLE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'T1790') && this.isDisplayed('T1790') && this.$refs.T1790 && this.$refs.T1790.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'T3252') && this.isDisplayed('T3252') && this.$refs.T3252 && this.$refs.T3252.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'URSSAF') && this.isDisplayed('URSSAF') && this.$refs.URSSAF && this.$refs.URSSAF.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'USER_DISABLED') && this.isDisplayed('USER_DISABLED') && this.$refs.USER_DISABLED && this.$refs.USER_DISABLED.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'VILLE') && this.isDisplayed('VILLE') && this.$refs.VILLE && this.$refs.VILLE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'FORME_JURIDIQUE_ID') && this.isDisplayed('FORME_JURIDIQUE_ID') && this.$refs.FORME_JURIDIQUE_ID && this.$refs.FORME_JURIDIQUE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'SALAIRE_MEANS_ID') && this.isDisplayed('SALAIRE_MEANS_ID') && this.$refs.SALAIRE_MEANS_ID && this.$refs.SALAIRE_MEANS_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRELEV_RIB_ID') && this.isDisplayed('PRELEV_RIB_ID') && this.$refs.PRELEV_RIB_ID && this.$refs.PRELEV_RIB_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'TRANCHE_EFFECTIF_ID') && this.isDisplayed('TRANCHE_EFFECTIF_ID') && this.$refs.TRANCHE_EFFECTIF_ID && this.$refs.TRANCHE_EFFECTIF_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_ID') && this.$refs.BRANCHE_ID) this.$refs.BRANCHE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('RETRAITE_COMPLEMENTAIRE_ID') && this.$refs.RETRAITE_COMPLEMENTAIRE_ID) this.$refs.RETRAITE_COMPLEMENTAIRE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('COMMERCIAL_ID') && this.$refs.COMMERCIAL_ID) this.$refs.COMMERCIAL_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('REPRESENTANT_ID') && this.$refs.REPRESENTANT_ID) this.$refs.REPRESENTANT_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_ID') && this.$refs.CONVENTION_ID) this.$refs.CONVENTION_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ACCORD_COLLECTIF') && this.$refs.ACCORD_COLLECTIF) this.$refs.ACCORD_COLLECTIF.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ALIAS') && this.$refs.ALIAS) this.$refs.ALIAS.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_CODE') && this.$refs.BRANCHE_CODE) this.$refs.BRANCHE_CODE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('BRANCHE_NOM') && this.$refs.BRANCHE_NOM) this.$refs.BRANCHE_NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONGES_SPEC') && this.$refs.CONGES_SPEC) this.$refs.CONGES_SPEC.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_CODE') && this.$refs.CONVENTION_CODE) this.$refs.CONVENTION_CODE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_NOM') && this.$refs.CONVENTION_NOM) this.$refs.CONVENTION_NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_CREATION') && this.$refs.DATE_CREATION) this.$refs.DATE_CREATION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FCAP') && this.$refs.FCAP) this.$refs.FCAP.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FNAS') && this.$refs.FNAS) this.$refs.FNAS.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENT_ASSOCIATION') && this.$refs.IDENT_ASSOCIATION) this.$refs.IDENT_ASSOCIATION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_SPECTACLE') && this.$refs.LICENCE_SPECTACLE) this.$refs.LICENCE_SPECTACLE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_STATUS') && this.$refs.LICENCE_STATUS) this.$refs.LICENCE_STATUS.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LICENCE_VALIDITE') && this.$refs.LICENCE_VALIDITE) this.$refs.LICENCE_VALIDITE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LOGO') && this.$refs.LOGO) this.$refs.LOGO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MODE_FACTURE') && this.$refs.MODE_FACTURE) this.$refs.MODE_FACTURE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYMENT_AUTO_SALAIRE') && this.$refs.PAYMENT_AUTO_SALAIRE) this.$refs.PAYMENT_AUTO_SALAIRE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_ADHESION') && this.$refs.POLE_EMPLOI_ADHESION) this.$refs.POLE_EMPLOI_ADHESION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_AFFILIATION') && this.$refs.POLE_EMPLOI_AFFILIATION) this.$refs.POLE_EMPLOI_AFFILIATION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('POLE_EMPLOI_IDENTIFIANT') && this.$refs.POLE_EMPLOI_IDENTIFIANT) this.$refs.POLE_EMPLOI_IDENTIFIANT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SIRET') && this.$refs.SIRET) this.$refs.SIRET.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SOUMIS_TVA') && this.$refs.SOUMIS_TVA) this.$refs.SOUMIS_TVA.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT_LICENCE_SPECTACLE') && this.$refs.STATUT_LICENCE_SPECTACLE) this.$refs.STATUT_LICENCE_SPECTACLE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('T1790') && this.$refs.T1790) this.$refs.T1790.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('T3252') && this.$refs.T3252) this.$refs.T3252.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('URSSAF') && this.$refs.URSSAF) this.$refs.URSSAF.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('USER_DISABLED') && this.$refs.USER_DISABLED) this.$refs.USER_DISABLED.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE') && this.$refs.VILLE) this.$refs.VILLE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FORME_JURIDIQUE_ID') && this.$refs.FORME_JURIDIQUE_ID) this.$refs.FORME_JURIDIQUE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SALAIRE_MEANS_ID') && this.$refs.SALAIRE_MEANS_ID) this.$refs.SALAIRE_MEANS_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRELEV_RIB_ID') && this.$refs.PRELEV_RIB_ID) this.$refs.PRELEV_RIB_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TRANCHE_EFFECTIF_ID') && this.$refs.TRANCHE_EFFECTIF_ID) this.$refs.TRANCHE_EFFECTIF_ID.save();
      },

      getValue (field: string): string {
         if (field == 'BRANCHE_ID') return this.brancheId.toString();
        else  if (field == 'RETRAITE_COMPLEMENTAIRE_ID') return this.retraiteComplementaireId.toString();
        else  if (field == 'COMMERCIAL_ID') return this.commercialId.toString();
        else  if (field == 'REPRESENTANT_ID') return this.representantId.toString();
        else  if (field == 'CONVENTION_ID') return this.conventionId.toString();
        else  if (field == 'ACCORD_COLLECTIF') return this.accordCollectif == null ? '' : this.accordCollectif.toString();
        else  if (field == 'ALIAS') return this.alias.toString();
        else  if (field == 'BRANCHE_CODE') return this.brancheCode.toString();
        else  if (field == 'BRANCHE_NOM') return this.brancheNom.toString();
        else  if (field == 'CONGES_SPEC') return this.congesSpec.toString();
        else  if (field == 'CONVENTION_CODE') return this.conventionCode.toString();
        else  if (field == 'CONVENTION_NOM') return this.conventionNom.toString();
        else  if (field == 'DATE_CREATION') return this.dateCreation.toString();
        else  if (field == 'FCAP') return this.fcap.toString();
        else  if (field == 'FNAS') return this.fnas.toString();
        else  if (field == 'IDENT_ASSOCIATION') return this.identAssociation.toString();
        else  if (field == 'LICENCE_SPECTACLE') return this.licenceSpectacle.toString();
        else  if (field == 'LICENCE_STATUS') return this.licenceStatus.toString();
        else  if (field == 'LICENCE_VALIDITE') return this.licenceValidite == null ? '' : this.licenceValidite.toString();
        else  if (field == 'LOGO') return this.logo.toString();
        else  if (field == 'MAIL') return this.mail.toString();
        else  if (field == 'MODE_FACTURE') return this.modeFacture.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'NUMERO') return this.numero.toString();
        else  if (field == 'PAYMENT_AUTO_SALAIRE') return this.paymentAutoSalaire.toString();
        else  if (field == 'POLE_EMPLOI_ADHESION') return this.poleEmploiAdhesion.toString();
        else  if (field == 'POLE_EMPLOI_AFFILIATION') return this.poleEmploiAffiliation.toString();
        else  if (field == 'POLE_EMPLOI_IDENTIFIANT') return this.poleEmploiIdentifiant.toString();
        else  if (field == 'SIRET') return this.siret.toString();
        else  if (field == 'SOUMIS_TVA') return this.soumisTva == null ? '' : this.soumisTva.toString();
        else  if (field == 'STATUT_LICENCE_SPECTACLE') return this.statutLicenceSpectacle.toString();
        else  if (field == 'T1790') return this.t1790.toString();
        else  if (field == 'T3252') return this.t3252.toString();
        else  if (field == 'URSSAF') return this.urssaf.toString();
        else  if (field == 'USER_DISABLED') return this.userDisabled.toString();
        else  if (field == 'VILLE') return this.ville.toString();
        else  if (field == 'FORME_JURIDIQUE_ID') return this.formeJuridiqueId.toString();
        else  if (field == 'SALAIRE_MEANS_ID') return this.salaireMeansId.toString();
        else  if (field == 'PRELEV_RIB_ID') return this.prelevRibId.toString();
        else  if (field == 'TRANCHE_EFFECTIF_ID') return this.trancheEffectifId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
